import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { IconName, ModalIconColor } from '@lib/components/Modal/enums';

export interface SsoErrorModalProps {
  errorCode: string | null;
  onClose: () => void;
}

function getErrorDescriptionKey(errorCode: string): string {
  const normalizedCode = errorCode.replace(/_/g, '-');
  return `sso-error-${normalizedCode}-description`;
}

function SsoErrorModal({ errorCode, onClose }: SsoErrorModalProps) {
  const { t, i18n } = useTranslation();

  const descriptionKey = errorCode
    ? getErrorDescriptionKey(errorCode)
    : 'sso-error-unknown-error-description';

  const description =
    errorCode && i18n.exists(descriptionKey)
      ? t(descriptionKey)
      : t('sso-error-unknown-error-description');

  return (
    <div data-test-id="login__sso-error-modal">
      <Modal
        isOpen={!!errorCode}
        icon={IconName.ErrorRed}
        iconColor={ModalIconColor.Red}
        title={t('sso-error-title')}
        description={description}
        actions={
          <ActionsRow
            actions={[
              <Button
                key="back"
                buttonText={t('back-to-log-in')}
                buttonType={ButtonTypes.primaryFilled}
                fullWidth
                onClick={onClose}
              />,
            ]}
          />
        }
      />
    </div>
  );
}

export default SsoErrorModal;
